module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', [_c('column', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Search new printers scheduler",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Search Printers Every ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.SettingsArray.SearchPrintersEvery),
      expression: "settingsData.SettingsArray.SearchPrintersEvery"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "28",
      "placeholder": "Days"
    },
    domProps: {
      "value": (_vm.settingsData.SettingsArray.SearchPrintersEvery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingsData.SettingsArray, "SearchPrintersEvery", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("Days")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Send Counters Every ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.SettingsArray.SendPrintersEvery),
      expression: "settingsData.SettingsArray.SendPrintersEvery"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "28",
      "placeholder": "Days"
    },
    domProps: {
      "value": (_vm.settingsData.SettingsArray.SendPrintersEvery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingsData.SettingsArray, "SendPrintersEvery", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("Days")])])])])]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Get printers info scheduler",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Search Printers Every ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.SettingsArray.SearchPrintersEvery),
      expression: "settingsData.SettingsArray.SearchPrintersEvery"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "28",
      "placeholder": "Days"
    },
    domProps: {
      "value": (_vm.settingsData.SettingsArray.SearchPrintersEvery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingsData.SettingsArray, "SearchPrintersEvery", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("Days")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Send Counters Every ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.SettingsArray.SendPrintersEvery),
      expression: "settingsData.SettingsArray.SendPrintersEvery"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "28",
      "placeholder": "Days"
    },
    domProps: {
      "value": (_vm.settingsData.SettingsArray.SendPrintersEvery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingsData.SettingsArray, "SendPrintersEvery", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("Days")])])])])]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Counter Configurations",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Search Printers Every ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.SettingsArray.SearchPrintersEvery),
      expression: "settingsData.SettingsArray.SearchPrintersEvery"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "28",
      "placeholder": "Days"
    },
    domProps: {
      "value": (_vm.settingsData.SettingsArray.SearchPrintersEvery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingsData.SettingsArray, "SearchPrintersEvery", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("Days")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Send Counters Every ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.SettingsArray.SendPrintersEvery),
      expression: "settingsData.SettingsArray.SendPrintersEvery"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "28",
      "placeholder": "Days"
    },
    domProps: {
      "value": (_vm.settingsData.SettingsArray.SendPrintersEvery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingsData.SettingsArray, "SendPrintersEvery", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("Days")])])])])]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Rules",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table no-margin"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Rule")]), _vm._v(" "), _c('th', [_vm._v("Condition")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th')])]), _vm._v(" "), (_vm.hasData) ? _c('tbody', _vm._l((_vm.rulesList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.Rule))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Condition))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Action))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right",
        "width": "80px"
      }
    }, [_c('a', {
      staticClass: "btn-flat danger",
      staticStyle: {
        "margin-left": "10px",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Edit"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      staticStyle: {
        "font-size": "20px",
        "color": "green"
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn-flat danger",
      staticStyle: {
        "margin-left": "10px",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Delete"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "font-size": "20px",
        "color": "red"
      }
    })])])])
  }), 0) : _vm._e()])])])])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Rules",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table no-margin"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Rule")]), _vm._v(" "), _c('th', [_vm._v("Condition")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th')])]), _vm._v(" "), (_vm.hasData) ? _c('tbody', _vm._l((_vm.rulesList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.Rule))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Condition))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Action))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right",
        "width": "80px"
      }
    }, [_c('a', {
      staticClass: "btn-flat danger",
      staticStyle: {
        "margin-left": "10px",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Edit"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      staticStyle: {
        "font-size": "20px",
        "color": "green"
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn-flat danger",
      staticStyle: {
        "margin-left": "10px",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Delete"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "font-size": "20px",
        "color": "red"
      }
    })])])])
  }), 0) : _vm._e()])])])]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Counter Configurations",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Search Printers Every ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.SettingsArray.SearchPrintersEvery),
      expression: "settingsData.SettingsArray.SearchPrintersEvery"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "28",
      "placeholder": "Days"
    },
    domProps: {
      "value": (_vm.settingsData.SettingsArray.SearchPrintersEvery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingsData.SettingsArray, "SearchPrintersEvery", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("Days")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Send Counters Every ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.SettingsArray.SendPrintersEvery),
      expression: "settingsData.SettingsArray.SendPrintersEvery"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "28",
      "placeholder": "Days"
    },
    domProps: {
      "value": (_vm.settingsData.SettingsArray.SendPrintersEvery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingsData.SettingsArray, "SendPrintersEvery", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("Days")])])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6676e0e7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsDealer.vue
// module id = 722
// module chunks = 0